module.exports = __webpack_public_path__ + "img/kompetenzdimensionen.a5c7477a.png";